"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInquiryOrderFormSearchModel = instanceOfInquiryOrderFormSearchModel;
exports.InquiryOrderFormSearchModelFromJSON = InquiryOrderFormSearchModelFromJSON;
exports.InquiryOrderFormSearchModelFromJSONTyped = InquiryOrderFormSearchModelFromJSONTyped;
exports.InquiryOrderFormSearchModelToJSON = InquiryOrderFormSearchModelToJSON;
exports.InquiryOrderFormSearchModelToJSONTyped = InquiryOrderFormSearchModelToJSONTyped;
/**
 * Check if a given object implements the InquiryOrderFormSearchModel interface.
 */
function instanceOfInquiryOrderFormSearchModel(value) {
    return true;
}
function InquiryOrderFormSearchModelFromJSON(json) {
    return InquiryOrderFormSearchModelFromJSONTyped(json, false);
}
function InquiryOrderFormSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'name': json['name'] == null ? undefined : json['name'],
        'cell': json['cell'] == null ? undefined : json['cell'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
        'fromId': json['fromId'] == null ? undefined : json['fromId'],
        'payStatus': json['payStatus'] == null ? undefined : json['payStatus'],
    };
}
function InquiryOrderFormSearchModelToJSON(json) {
    return InquiryOrderFormSearchModelToJSONTyped(json, false);
}
function InquiryOrderFormSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'name': value['name'],
        'cell': value['cell'],
        'useStatus': value['useStatus'],
        'fromId': value['fromId'],
        'payStatus': value['payStatus'],
    };
}
